import React from 'react';
import PropTypes from 'prop-types';
import styles from './Select.module.scss';
import SelectMenuItem from './SelectMenuItem'


const SelectMenu = (props) => {
  const { options, handleChange, selected, multiselect } = props
  const option = options.map(option => 
    <div onClick={() => handleChange(option)} key={`${option.value}${option.id}`}>
      <SelectMenuItem option={option} {...props} active={selected.find((item) => { return item.id === option.id })} multiselect={multiselect} />
    </div>
  );

  return <div className={styles.menu}>{option}</div>
}


SelectMenu.propTypes = {
  options: PropTypes.array,
}

export default SelectMenu;